export enum BlockStatusEnum {
  FullBlocked = 6,
  Unblocked = 16,
}
